import FileModal from './FileModal';
import { withI18n } from 'react-i18next';

export default withI18n()(FileModal);
